import { DataSourceStoreState } from './data-sources-store.types';

export const STORE_NAME: string = 'DATA_SOURCES';

export const initialState: DataSourceStoreState = {
  sources: [],
  primarySource: null,
};
